module.exports = __webpack_public_path__ + "static/iron-sting-f20368ba0529eb650f5f842645647c02.png";